import {
  SalaryGroupServiceSettingsThresholdType,
  ThresholdInForm,
} from '@expane/logic/salarySettings'

export interface SalarySettingServiceThresholdDialogDialogProps {
  type: SalaryGroupServiceSettingsThresholdType
  closeDialog: () => void
  onChange: (thresholds: ThresholdInForm[]) => void
  initialThresholds: ThresholdInForm[]
  currencySymbol: string
}

export interface SalarySettingServiceThresholdFormValues {
  thresholds: ThresholdInForm[]
}

export const getThresholdsText = (
  thresholds: ThresholdInForm[],
  type: SalaryGroupServiceSettingsThresholdType,
  currencySymbol: string,
): string => {
  const thresholdsText = thresholds.map(
    threshold =>
      `${threshold.qty}+ - ${threshold.value} ${type === 'percentage' ? '%' : currencySymbol}`,
  )

  return thresholdsText.join(', ')
}
